export const INVITE_MONTHLY_QUOTA_FIRST_YEAR = 10
export const INVITE_MONTHLY_QUOTA_AFTER_FIRST_YEAR = 5
